import { ArrowClockwise, WarningCircle } from "@phosphor-icons/react";

export default function LoadError({ error, onRetry, message }) {
  return (
    <div
      data-testid="load-error"
      className="bg-[#FDEDED] border border-[#C05746]/30 rounded-sm p-5 flex flex-col md:flex-row md:items-center gap-3"
    >
      <WarningCircle size={22} weight="duotone" color="#C05746" />
      <div className="flex-1 text-sm text-[#C05746]">
        <div className="font-bold">{message || "Não foi possível carregar os dados."}</div>
        {error && <div className="text-xs opacity-80 mt-1">{error}</div>}
      </div>
      {onRetry && (
        <button
          data-testid="retry-btn"
          onClick={onRetry}
          className="inline-flex items-center gap-2 border border-[#C05746] text-[#C05746] hover:bg-white font-bold text-sm px-4 py-2 rounded-sm"
        >
          <ArrowClockwise size={14} weight="bold" /> Tentar novamente
        </button>
      )}
    </div>
  );
}
